import PropTypes from 'prop-types';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Hooks/useAuth';
import Drawer from './drawer';
import Sidebar from '../SideBar/sidebar';
import UserSession from '../../Utils/userSession';
import { useDrawer } from '../../Hooks/useDrawer';
import { Header } from '../../Components/Header';


const MainContentWrapper = ({ children, hideHeaderOnDesktop = false }) => {
  const { loggedIn, user, userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isDesktopView = useMediaQuery(theme.breakpoints.up('md'));
  const {isOpen, toggleDrawer} = useDrawer();
  const hideSearchOnMobileRoutes = ['/all-properties', '/my-properties', '/property-list', '/admin-portal', '/users'];
  const hideSearchOnMobile = hideSearchOnMobileRoutes.some(
    (routePath) => location.pathname.startsWith(routePath),
  );

  const handleSearch = (query) => {
    if (!query || query.trim() === '') {
      sessionStorage.removeItem('propertySearchQuery');
      sessionStorage.setItem('propertyIsSearchMode', 'false');
      navigate('/');
    } else {
      const normalizedQuery = query.trim();
      sessionStorage.setItem('propertySearchQuery', normalizedQuery);
      sessionStorage.setItem('propertyIsSearchMode', 'true');
      navigate('/', {
        state: {
          seoSearchQuery: normalizedQuery,
        },
      });
    }
  };

  const handleHomeClick = () => {
    sessionStorage.removeItem('propertiesCache');
    navigate('/', { state: { homeRefreshAt: Date.now() } });
  };
  const handleListPropertyClick = () => navigate('/my-properties');
  const handleMyPropertiesClick = () => navigate('/my-properties');
  const handleManageMyPropertiesClick = () => navigate('/property-list');
  const handleAdminPortalClick = () => navigate('/admin-portal');
  const handleAllPropertiesClick = () => navigate('/all-properties');
  const handleUsersClick = () => navigate('/users');
  const handleSavedPropertiesClick = () => navigate('/saved-properties');
  const handleMyProfileClick = () => navigate('/my-profile');
  const handleSignIn = () => navigate('/login');
  const handleSignOut = () => {
    logout();
    navigate('/');
  };
  const roleId = user?.role_id ?? user?.roleId ?? userProfile?.role_id ?? userProfile?.roleId;
  const isAdmin = Number(roleId) === 1;

  return loggedIn ? (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      {isDesktopView && (
        <Sidebar
          isOpen={isOpen}
          onToggle={toggleDrawer}
          screenWidth={isDesktopView}
          Drawer={Drawer}
        />
      )}
      <Box component="main" sx={{ flexGrow: 1 }}>
        {!(hideHeaderOnDesktop && isDesktopView) && (
          <Header
            onHomeClick={handleHomeClick}
            onListPropertyClick={handleListPropertyClick}
            onMyPropertiesClick={handleMyPropertiesClick}
            onManageMyPropertiesClick={handleManageMyPropertiesClick}
            onAdminPortalClick={handleAdminPortalClick}
            onUnderVerificationClick={handleAllPropertiesClick}
            onAllPropertiesClick={handleAllPropertiesClick}
            onUsersClick={handleUsersClick}
            onSavedPropertiesClick={handleSavedPropertiesClick}
            onMyProfileClick={handleMyProfileClick}
            isLoggedIn={loggedIn}
            isAdmin={isAdmin}
            userEmail={user?.email || userProfile?.email}
            onSignIn={handleSignIn}
            onSignOut={handleSignOut}
            hideSearchOnMobile={hideSearchOnMobile}
            onSearch={handleSearch}
          />
        )}
        <div>{children}</div>
      </Box>
      <UserSession/>
    </Box>
  ) : (
    <div>{children}</div>
  );
};

MainContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  hideHeaderOnDesktop: PropTypes.bool,
};

export default MainContentWrapper;
